import axios from "axios";
import React, { Component } from "react";

class Video extends Component {
  constructor(props) {
    super(props);
    this.onFileChange = this.onFileChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
        profileImg: ''
    }
}
onFileChange(e) {
    this.setState({ profileImg: e.target.files[0] })
}
onSubmit(e) {
    e.preventDefault()
    const formData = new FormData()
    formData.append('profileImg', this.state.profileImg)
    axios.post("https://api.homedotapp.com/api/user-profile", formData, {
    }).then(res => {
        console.log(res)
    })
}

render() {
    return (
        <div className="container">
            <div className="row">
                <form onSubmit={this.onSubmit}>
                    <div className="form-group">
                        <input type="file" onChange={this.onFileChange} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary" type="submit">Upload</button>
                    </div>
                </form>
            </div>
        </div>
    )
}
}

export default Video;
